import { AuthFormHeaderProps } from './type';

export const AuthFormHeader = ({ children }: AuthFormHeaderProps) => <div className="flex flex-col">{children}</div>;
